import { takeData } from '../../../shared/misc';
import { decompressValue } from './utils';
import { setAppConfig } from '../model/app-config';

const isCmsSetting = (v) => typeof v.value === 'string' && typeof v.id === 'number';

const resolveData = (data) => (isCmsSetting(data)
  ? decompressValue(data)
  : data);

export const fetchProduction = async () => {
  const url = new URL(window.location.origin);
  url.pathname = '/cms-settings/production/app_config_false.json';

  return fetch(url)
    .then(takeData)
    .then(resolveData)
    .catch(() => import('./app-not-found.js').then((module) => module.default))
    .then(setAppConfig);
};
